import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";
import { formatRange } from "@/lib/time";
import { getCategory } from "@/lib/categories";
import { useTranslation } from "@/i18n";

export default function OverlapDialog({ open, onOpenChange, segment, eventsById }) {
  const { t } = useTranslation();
  if (!segment) return null;
  const involved = segment.eventIds
    .map((id) => eventsById[id])
    .filter(Boolean)
    .sort((a, b) => a.startMinutes - b.startMinutes);

  const tone = segment.count >= 3 ? "black" : "red";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-2xl" data-testid="overlap-dialog">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <span
              className="inline-flex items-center justify-center h-9 w-9 rounded-full"
              style={{
                backgroundColor: tone === "black" ? "#0F172A" : "#EF4444",
                color: "white",
              }}
            >
              <AlertTriangle className="h-4 w-4" />
            </span>
            <div>
              <DialogTitle className="font-display tracking-tight">
                {t("overlap.eventsOverlap", { count: segment.count })}
              </DialogTitle>
              <p className="text-xs text-slate-500 mt-0.5">
                {tone === "black" ? t("overlap.threeOrMore") : t("overlap.twoConflict")}
              </p>
            </div>
          </div>
        </DialogHeader>

        <ul className="space-y-2 mt-2" data-testid="overlap-event-list">
          {involved.map((ev) => {
            const cat = getCategory(ev.category);
            return (
              <li
                key={ev.id}
                className="flex items-center gap-3 rounded-xl border border-border p-3"
                data-testid={`overlap-event-${ev.id}`}
              >
                <span
                  className="h-8 w-8 rounded-md shrink-0 border border-black/5"
                  style={{ backgroundColor: cat.hex }}
                  aria-hidden
                />
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-slate-900 truncate">{ev.title}</p>
                  <p className="text-xs text-slate-500 font-mono-tab">{formatRange(ev)}</p>
                </div>
                <span className="text-[10px] uppercase tracking-wider text-slate-500">
                  P{ev.priority}
                </span>
              </li>
            );
          })}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
